
import { Component, Vue, Prop } from "vue-property-decorator";
import BaseCard from "@/components/base/BaseCard.vue";
import FormModal from "@/components/base/FormModal.vue";
import { IBaseAutocomplete } from "@/types";
import { Advertiser } from "@/services/advertiser/Advertiser";
import { IAffiliate } from "@/api/types/revenue";
import { eventBus } from "@/eventbus";
import BaseAutocomplete from "@/components/base/design/BaseAutocomplete.vue";
import { getAffiliateSearch } from "@/api/user";
import { ITableHeader } from "@/utils";
import BaseTable from "@/components-UI/table/BaseTable.vue";
import BaseButton from "@/components-UI/BaseButton.vue";
import SvgTrash from "@/assets/icons/trash.svg";
import { CellsType, prepareItems, RawConfig } from "@/utils/CellsFactory";
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";
import SvgPlus from "@/assets/icons/plus.svg";
import BaseListItem from "@/components-UI/list/BaseListItem.vue";
import BaseList from "@/components-UI/list/BaseList.vue";

@Component({
    components: {
        BaseEditableCard,
        SvgTrash,
        BaseButton,
        BaseAutocomplete,
        FormModal,
        BaseCard,
        BaseTable,
        SvgPlus,
        BaseListItem,
        BaseList,
    },
})

export default class AdvertisersAffiliates extends Vue {
    @Prop({ required: true }) advertiser!: Advertiser;
    @Prop() disableTitleButton!: boolean;

    isShowModal: boolean = false;
    isShowDeleteModal: boolean = false;
    isLoading: boolean = false;
    affiliateId: number | null = null;
    headers: ITableHeader[]  = [
        { text: 'ID', value: 'id', width: 'auto' },
        { text: 'Имя', value: 'name', width: 'auto' },
        { text: 'Email', value: 'email', width: 'auto' },
        { text: '', value: 'actions', align: 'center', width: '30px' },
    ];
    config: RawConfig<any> = {
        [CellsType.Route]: {
            id: {
                name: 'affiliate',
                valueKey: 'id',
                text: 'id',
                isChip: true,
            },
        },
        [CellsType.Uniq]: {
            actions: {},
        },
    };

    get getFormatedItems(): any {
        const columns = this.headers.map(el => el.value);
        return prepareItems(this.getItems, this.config, columns);
    }

    get getItems(): IAffiliate[] {
        return this.advertiser.affiliates || [];
    }

    get getAffiliateData(): IBaseAutocomplete {
        return {
            apiMethod: getAffiliateSearch,
            errorText: 'Партнер не найден',
            placeholder: 'Выберите партнёра',
            itemValue: 'id',
            template: (item) => `${item.id} ${item.first_name} ${item.last_name} ${item.email}`,
        };
    }

    closeModal(): void {
        this.isLoading = false;
        this.isShowModal = false;
        this.affiliateId = null;
        eventBus.$emit('clear');
        this.isShowDeleteModal = false;
    }

    changeAffiliate(id: number): void {
        this.affiliateId = id;
    }

    async addAffiliate(): Promise<void> {
        if (!this.affiliateId) {
            this.closeModal();
            return;
        }
        this.isLoading = true;
        await this.advertiser.addAffiliate(this.affiliateId);
        this.closeModal();
    }

    prepareDeleteForm(id: number): void {
        this.affiliateId = id;
        this.isShowDeleteModal = true;
    }

    async deleteAffiliate(): Promise<void> {
        if (!this.affiliateId) return;
        this.isLoading = true;
        await this.advertiser.deleteAffiliate(this.affiliateId);
        this.closeModal();
    }
}
